import { useCallback, useMemo } from 'react';

import { CONSENT_TYPE_PHYSICAL_DAMAGE_DECLINE } from '../constants';
import { useCoverageConsentConfirmation } from './useCoverageConsentConfirmation';

interface UsePhysicalDamageDeclineConfirmationOptions {
  quoteId: number;
  vehicleVin: string;
  vehicleId: number;
  onConfirmDecline: () => void;
}

export const usePhysicalDamageDeclineConfirmation = ({
  quoteId,
  vehicleVin,
  vehicleId,
  onConfirmDecline,
}: UsePhysicalDamageDeclineConfirmationOptions) => {
  const onApplyChange = useCallback(() => {
    onConfirmDecline();
  }, [onConfirmDecline]);

  const shouldClearOther = useCallback(() => false, []);

  const {
    requestConfirmation,
    resetState,
    modalProps: baseModalProps,
  } = useCoverageConsentConfirmation({
    quoteId,
    vehicleVin,
    vehicleId,
    consentType: CONSENT_TYPE_PHYSICAL_DAMAGE_DECLINE,
    onApplyChange,
    shouldClearOther,
  });

  const triggerConfirmation = useCallback(() => {
    requestConfirmation('', '');
  }, [requestConfirmation]);

  const modalProps = useMemo(
    () => ({
      isOpen: baseModalProps.isOpen,
      onClose: baseModalProps.onClose,
      onConfirm: baseModalProps.onConfirm,
      isLoading: baseModalProps.isLoading,
    }),
    [baseModalProps],
  );

  return {
    triggerConfirmation,
    resetState,
    modalProps,
  };
};
